// import { useState } from "react";
import "../assets/styles/card.css";
import { useDispatch } from "react-redux";
import { turnCard } from "../features/boardSlice";

// const cardStyle = [
//   { width: "20vw", height: "20vw", fontSize: "12vw" },
//   { width: "13vw", height: "13vw", fontSize: "9vw" },
//   { width: "8vw", height: "8vw", fontSize: "5vw" },
//   { width: "7vw", height: "7vw", fontSize: "4vw" },
// ];

const cardStyle = [
  {
    width: "20vw",
    height: "20vw",
    fontSize: "70px",
    maxWidth: "200px",
    maxHeight: "200px",
  },
  {
    width: "13vw",
    height: "13vw",
    fontSize: "40px",
    maxWidth: "120px",
    maxHeight: "120px",
  },
  {
    width: "8vw",
    height: "8vw",
    fontSize: "28px",
    maxWidth: "70px",
    maxHeight: "70px",
  },
  {
    width: "7vw",
    height: "7vw",
    fontSize: "23px",
    maxWidth: "50px",
    maxHeight: "50px",
  },
];

const Card = ({ name, show, id, level }) => {
  const dispatch = useDispatch();

  return (
    <div className="flip-card" style={cardStyle[level]}>
      <div
        className={`flip-card-inner ${show ? "flip" : ""}`}
        onClick={() => {
          dispatch(turnCard(id));
        }}
      >
        <div className="flip-card-front">☓</div>
        <div className="flip-card-back">
          <div>{name}</div>
        </div>
      </div>
    </div>
  );
};

export default Card;
